export default __webpack_public_path__ + "static/media/bulk_spirit.dcfd08e1.svg";